import React, { useMemo, useCallback } from 'react'
import { useDataValue } from 'Simple/Data.js'
import {
  buildFilterModel,
  buildExternalFilterConfig,
  useTablePreset,
} from './helpers.js'
import { ClearFiltersStatusPanel } from 'design-system/AgGrid/react.js'

import View from './view.js'

export default function Logic(props) {
  let group_columns = useDataValue({
    context: 'report',
    path: 'report_type_values',
    viewPath: props.viewPath,
  })

  let report_type = useDataValue({
    context: 'report',
    path: 'type',
    viewPath: props.viewPath,
  })

  let tablePreset = useTablePreset(props)

  let accounts_receivable_filters = useDataValue({
    context: 'report',
    path: 'accounts_receivable_filters',
    viewPath: props.viewPath,
  })

  let filterModel = useMemo(
    () => buildFilterModel(accounts_receivable_filters, report_type),
    [accounts_receivable_filters, report_type]
  )

  let externalFilterConfig = useMemo(
    () => buildExternalFilterConfig(accounts_receivable_filters, report_type),
    [accounts_receivable_filters, report_type]
  )

  let isExternalFilterPresent = useCallback(
    () => externalFilterConfig.enabled,
    [externalFilterConfig.enabled]
  )

  // External filter: pass rows where any condition is true
  let doesExternalFilterPass = useCallback(
    params => {
      if (!externalFilterConfig.enabled) {
        return true
      }

      let row = params.data
      let conditions = []

      if (externalFilterConfig.selectedBuckets.length > 0) {
        let bucketMatch = externalFilterConfig.selectedBuckets.some(
          bucket => row[bucket] > 0
        )
        conditions.push(bucketMatch)
      }

      if (externalFilterConfig.include_future_due) {
        if (externalFilterConfig.include_credits) {
          conditions.push(row.FUTURE_DUE !== 0)
        } else {
          conditions.push(row.FUTURE_DUE > 0)
        }
      }

      // we only want less than because if we add a > 0 it will include
      // all rows which defeats the purpose of the buckets filters
      if (externalFilterConfig.include_credits) {
        conditions.push(row.ACCOUNT_RECEIVABLES < 0)
      }

      return conditions.some(Boolean)
    },
    [externalFilterConfig]
  )

  let statBar = useMemo(
    () => ({
      toolPanels: ['columns', 'filters'],
      defaultToolPanel: null,
    }),
    []
  )

  let statusBar = useMemo(
    () => ({
      statusPanels: [
        {
          statusPanel: ClearFiltersStatusPanel,
          align: 'left',
        },
        {
          statusPanel: 'agTotalAndFilteredRowCountComponent',
        },
        {
          statusPanel: 'agTotalRowCountComponent',
        },
        {
          statusPanel: 'agFilteredRowCountComponent',
        },
        {
          statusPanel: 'agSelectedRowCountComponent',
        },
        {
          statusPanel: 'agAggregationComponent',
          statusPanelParams: {
            aggFuncs: ['count', 'sum', 'min', 'max', 'avg'],
          },
        },
      ],
    }),
    []
  )

  return (
    <View
      {...props}
      sideBar={statBar}
      statusBar={statusBar}
      columnsVisible={group_columns}
      filterModel={filterModel}
      isExternalFilterPresent={isExternalFilterPresent}
      doesExternalFilterPass={doesExternalFilterPass}
      tablePreset={tablePreset}
    />
  )
}
